export const DATETIME = 'Timestamp'
export const RTE = 'StructuredText'
export const PATH = 'Link.document'
export const SELECT = 'Select'
export const LINK = 'Link.web'
export const GROUP = 'Group'
export const IMAGE = 'Image'
export const TEXT = 'Text'



// WEBPACK FOOTER //
// ./src/api/utils/types.js